// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en/home.json";
import id from "./locales/id/home.json";
import en_about from "./locales/en/about.json";
import id_about from "./locales/id/about.json";
import en_contact from "./locales/en/contact.json";
import id_contact from "./locales/id/contact.json";
import en_contactForm from "./locales/en/contactForm.json";
import id_contactForm from "./locales/id/contactForm.json";
import en_productDetail from "./locales/en/productDetail.json";
import id_productDetail from "./locales/id/productDetail.json";
import en_productsList from "./locales/en/productsList.json";
import id_productsList from "./locales/id/productsList.json";
import en_nav from "./locales/en/nav.json";
import id_nav from "./locales/id/nav.json";
import en_services from "./locales/en/services.json";
import id_services from "./locales/id/services.json";
import en_whatsapp from "./locales/en/whatsapp.json";
import id_whatsapp from "./locales/id/whatsapp.json";
import en_common from "./locales/en/common.json";
import id_common from "./locales/id/common.json";


i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { home: en, about: en_about, contact: en_contact, contactForm: en_contactForm, productDetail: en_productDetail, productsList: en_productsList, nav: en_nav, services: en_services, whatsapp: en_whatsapp, common: en_common }, id: { home: id, about: id_about, contact: id_contact, contactForm: id_contactForm, productDetail: id_productDetail, productsList: id_productsList, nav: id_nav, services: id_services, whatsapp: id_whatsapp, common: id_common } },



    fallbackLng: "en",
    ns: ["home", "about", "contact", 'contactForm', 'productDetail','productsList','nav','services','whatsapp','common'],  

    defaultNS: "home",
    interpolation: { escapeValue: false },
  });

export default i18n;
